import store from "@/store";

export function getLanguageDisplayName(languageCode: string | null | undefined) {
  if (!languageCode) return "";
  const currentLocale = store.state.userSettings.CurrentLocale;
  const displayNames = new Intl.DisplayNames([currentLocale], { type: "language" });
  return displayNames.of(languageCode);
}
